<template>
  <Collapsible :forceOpen="roomPickerOpen">
  <div slot="header" class="container" v-if="room">
    <div class="button-group noselect">
      <span class="button button-icon button-left" @click.stop="onPrev($event)"><i class="material-icons bold">navigate_before</i></span>
      <span class="button button-middle" @click.stop="onRoomSelectToggle()">{{room.name}}</span>
      <span class="button button-icon button-right" @click.stop="onNext($event)"><i class="material-icons bold">navigate_next</i></span>
    </div>
  </div>
  <div class="room-select-wrap">
    <div v-for="r in rooms" :key="r.id"
      class="room-listing-button noselect"
      :class="{'active': (room.id === r.id)}"
      @click.stop="onRoomSelect(r.id)"
      >
      {{r.name}}
    </div>
  </div>
  </Collapsible>
</template>

<script>

import { mapGetters } from 'vuex';

import types from './../store/types'
import Room from './../store/modules/room/types'
import Collapsible from '@/components/Collapsible'

export default {
  name: 'RoomSelectGadget',
  props: ['roomId'],
  components: { Collapsible },
  data () {
    return {
      roomPickerOpen: false
    }
  },
  methods: {
    onPrev () {
      this.changeRoom(-1);
    },
    onNext () {
      this.changeRoom(1);
    },
    onRoomSelectToggle () {
      this.roomPickerOpen = !this.roomPickerOpen;
    },
    onRoomSelect (roomId) {
      this.$emit('update', roomId);
      this.roomPickerOpen = false;
    },
    changeRoom (change) {
      const index = this.rooms.findIndex(r => r.id === this.room.id);

      if (index !== -1) {
        const newIndex = index + change;
        const newRoom = this.rooms[newIndex];

        if (newRoom) {
          this.$emit('update', newRoom.id);
        }
      }
    },
  },
  computed: {
    room () {
      const room = this.getRoomById(this.roomId);
      console.log('room:', room);
      return room;
    },
    rooms () {
      return this.getRooms();
    },
    ...mapGetters('Room', [
      Room.getters.GET_ROOM_BY_ID,
      Room.getters.GET_ROOMS
    ])
  }
}
</script>

<style lang="scss" scoped>

  @import 'src/color.scss';
  @import 'src/values.scss';

  $height: 2em;
  $radius: 0.0em;

  .container {
    display: inline-block;
    width: 100%;
    height: 2.5em;
  }

  .button-group {
    display: table;
    width: 100%;
    height: 100%;
  }

  .button {
    color: $secondary-text;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    //background: -webkit-linear-gradient($secondary-light, $secondary 120%);
    background: $secondary;
    //border: 1px solid $secondary-dark;
    padding: 0;
    font-weight: bold;
    cursor: pointer;

    transition: $transition-time all;
    &:hover {
      background-color: $secondary-dark;
    }
  }
  .button:focus {
    border-color: $secondary-dark
  }

  .button-left {
    border-top-left-radius: $radius;
    border-bottom-left-radius: $radius;
  }

  .button-middle {
    border-left: none;
    border-right: none;
  }

  .button-right {
    border-top-right-radius: $radius;
    border-bottom-right-radius: $radius;
  }

  .button-icon {
    width: 14%;
  }

  .bold {
    font-weight: bold;
  }

  .room-select-wrap {
    //border: 1px solid $table-border-color;
    padding-bottom: 0.5em;
  }

  .room-listing-button {
    width: 100%;
    background: white;
    //border: 1px solid $table-border-color;
    padding: 0.3em 0;
    cursor: pointer;
    font-weight: bold;
    box-sizing: border-box;

    &.active {
      background: $secondary-light;
      color: $secondary-text;
    }
    &:hover {
      background: $secondary;
      color: $secondary-text;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/RoomSelectGadget.vue